import { useQuery } from "@tanstack/react-query";
import { AppNotification } from "../components/notifications/NotificationsDropdown";
import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";

interface INotificationResponse extends DefaultResponseWithData<AppNotification[]> { }

export default function useAppNotifications(){
  const { get } = useApiHelper();

  const workOrderNotifications = useQuery({
    queryKey: ["workOrderNotifications"],
    queryFn: () => get<INotificationResponse>("/notification/workorders"),
    enabled: true,
    staleTime: 1000 * 60 * 5,
  });

  return {
    workOrderNotifications
  };
}